import { PropsWithChildren, createContext, useContext } from "react";

const defaultVariant = {
  tableWrap: false,
  openInternalLinksInNewTab: false,
  hideFootnoteLabels: false,
};

type VariantProps = typeof defaultVariant;

const VariantContext = createContext<VariantProps>(defaultVariant);

// eslint-disable-next-line react-refresh/only-export-components
export const useVariant = () => useContext(VariantContext);

/**
 * Used for styling a Markdown block element with a class, e.g.
 *
 * <Variant tableWrap>
 *
 * |   | A | B | C |
 * |---|---|---|---|
 * | 1 |   |   |   |
 * | 2 |   |   |   |
 * | 3 |   |   |   |
 *
 * </Variant>
 */
export const Variant = ({
  children,
  ...variants
}: PropsWithChildren<Partial<VariantProps>>) => (
  <VariantContext.Provider value={{ ...defaultVariant, ...variants }}>
    {children}
  </VariantContext.Provider>
);
